// Blog post constants - edit these in one place to update across all posts

export const BLOG_DISCLAIMER = `Disclaimer: This content is for entertainment and educational purposes only. The views 
and opinions expressed are solely those of the individuals making statements and do not 
constitute legal advice. Readers and viewers should consult with qualified legal professionals for 
advice specific to their situation.`;
